import React from 'react';
import { observer } from 'mobx-react-lite';
import NotificationSettings from '@/components/NotificationSettings';
import { PaymentSchemeTemplatesSection } from '@/components/PaymentSchemeTemplatesSection';
import './SettingsPage.css';

/**
 * Страница настроек админ-панели
 */
const SettingsPage: React.FC = observer(() => {
  return (
    <div className="settings-page" data-testid="settings-page">
      <div className="settings-page__container">
        <header className="settings-page__header">
          <h1 className="settings-page__title">Настройки</h1>
          <p className="settings-page__description">
            Управление параметрами и настройками админ-панели
          </p>
        </header>

        <div className="settings-page__content">
          {/* Секция уведомлений */}
          <section className="settings-page__section" data-testid="settings-section-notifications">
            <NotificationSettings />
          </section>

          <section className="settings-page__section" data-testid="settings-section-payment-scheme-templates">
            <PaymentSchemeTemplatesSection />
          </section>

          {/* Здесь можно добавить другие секции настроек в будущем */}
          {/* 
          <section className="settings-page__section">
            <ProfileSettings />
          </section>
          
          <section className="settings-page__section">
            <SecuritySettings />
          </section>
          */}
        </div>
      </div>
    </div>
  );
});

SettingsPage.displayName = 'SettingsPage';

export default SettingsPage;
